import { render } from "./DocumentHistory.vue?vue&type=template&id=0fb0cb63&scoped=true"
import script from "./DocumentHistory.vue?vue&type=script&lang=js"
export * from "./DocumentHistory.vue?vue&type=script&lang=js"

import "./DocumentHistory.vue?vue&type=style&index=0&id=0fb0cb63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb0cb63"]])

export default __exports__